<template>
    <div class="bg-light-red vh-100">
        <!-- Header -->
        <div class="header position-relative bg-gradient-danger h-75vh">
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg
                    x="0"
                    y="0"
                    viewBox="0 0 2560 100"
                    preserveAspectRatio="none"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <polygon
                        class="bg-light-red"
                        points="2560 0 2560 101 0 101" />
                </svg>
            </div>
        </div>
        <div class="card-wrapper d-flex align-items-center justify-content-center flex-column">
            <div class="card w-50">
                <div
                    v-if="error.statusCode !== 500"
                    class="card-body">
                    <h1>{{ $t("error." + (error.message.message ? error.message.message : error.message)) }}</h1>
                    <div class="mb-4">
                        {{ $t("error." + (error.message.message ? error.message.message : error.message) + "_help") }}
                    </div>
                    <div v-if="error.data && error.data.kontakt">
                        <div>{{ error.data.kontakt.anrede }}</div>
                        <div>
                            {{ error.data.kontakt.Vornamee }}
                            {{ error.data.kontakt.Nachname }}
                        </div>
                        <div v-if="error.data.kontakt.hauptanschrift">
                            {{ error.data.kontakt.hauptanschrift.PLZ }}
                            {{ error.data.kontakt.hauptanschrift.Ort }}
                        </div>
                        <div v-if="error.data.kontakt.hauptanschrift">
                            {{
                                error.data.kontakt.hauptanschrift.Strasse
                            }}
                            {{ error.data.kontakt.hauptanschrift.Hausnummer }}
                        </div>
                        <div>{{ error.data.kontakt.mail }}</div>
                        <div>{{ error.data.kontakt.telefon }}</div>
                    </div>
                </div>
                <div
                    v-else
                    class="card-body">
                    <h1>{{ $t("error.server_error") }}</h1>
                    <div class="mb-4">
                        {{ $t("error.server_error_help") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    error: Object
})
</script>

<style lang="scss" scoped>
@use "sass:color";

.h-75vh {
    height: 75vh;
}

.bg-light-red {
    background: color.adjust($danger, $lightness: -15%);
    fill: color.adjust($danger, $lightness: -15%);
}

.card-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}

.separator {
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    width: 100%;
    height: 150px;
    transform: translateZ(0);
    overflow: hidden;
    pointer-events: none;

    svg {
        position: absolute;
        pointer-events: none;
    }
}

.separator-top {
    top: 0;
    bottom: auto;

    svg {
        top: 0;
    }
}

.separator-bottom {
    top: auto;
    bottom: 0;

    svg {
        bottom: 0;
    }
}

.separator-inverse {
    transform: rotate(180deg);
}

// Styles

.separator-skew {
    height: 60px;

    @include media-breakpoint-up(xl) {
        height: 70px;
    }
}
</style>
